export enum ScheduleStatusEnum {
    ACTIVE_SCHEDULED,
    ACTIVE_SCHEDULED_AND_TRIGGERED,
    ACTIVE_TRIGGERED,
    ACTIVE_UNSCHEDULED,
    PAUSED_SCHEDULED,
    PAUSED_UNSCHEDULED
}
